import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=80b58f10&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=80b58f10&scoped=true&lang=scss"
import style1 from "./Setting.vue?vue&type=style&index=1&id=80b58f10&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b58f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80b58f10')) {
      api.createRecord('80b58f10', component.options)
    } else {
      api.reload('80b58f10', component.options)
    }
    module.hot.accept("./Setting.vue?vue&type=template&id=80b58f10&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('80b58f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/Setting.vue"
export default component.exports